import styled from 'styled-components';
import theme from 'lib/theme';
import * as tokens from 'styles';
import BaseLayout from 'components/Layout/Base';

const background = theme({
  fallback: 'none',
  duoLight: 'none',
  duoDark: `${tokens.sunflower}`,
  familyLight: 'none',
  familyDark: `${tokens.storm155}`,
});

const textColor = theme({
  fallback: tokens.gray10,
  duoLight: tokens.gray10,
  duoDark: tokens.black,
  familyLight: tokens.gray10,
  familyDark: tokens.black,
});

const Bare = styled(BaseLayout).attrs({ 'aria-live': 'polite' })<{
  backgroundOverride?: string;
}>`
  background: ${({ backgroundOverride }) => backgroundOverride || background};
  color: ${textColor};
  width: 100%;
`;

export default Bare;
